export default __webpack_public_path__ + "static/derattizzazione-2056e2c70dd403ec1f2fd03ac53475b7.png";